import { LuChartColumn, LuImages, LuSearch, LuSparkles } from 'react-icons/lu';

// Sections of a report: the sidebar links to them, WeeklyReport renders them (?tab=…).
// `count`: the figure the sidebar shows next to the tab, among those WeeklyReport publishes.
export const DEFAULT_REPORT_TAB = 'analyses';

const REPORT_TABS = [
  { id: 'analyses', label: 'Analyses', icon: LuSparkles, count: 'analyses' },
  { id: 'gallery', label: 'Galerie', icon: LuImages, count: 'pictures' },
  { id: 'stats', label: 'Statistiques', icon: LuChartColumn, admin: true },
  { id: 'search', label: 'Recherche', icon: LuSearch, admin: true },
];

export const getReportTabs = (isAdminUser) => REPORT_TABS.filter((tab) => !tab.admin || isAdminUser);

export const reportTabHref = (slug, reportId, tabId) => (
  `/w/${slug}/${reportId}${tabId === DEFAULT_REPORT_TAB ? '' : `?tab=${tabId}`}`
);
